import { Component, Input, OnInit } from "@angular/core";
import { NotificacaoService } from "../services/notificacao.service";
import { CarregandoService } from "../services/carregando.service";
import { FinanciadoraIntegradorModel } from "../financiamento/models/financiadora-integrador-model";
import { FinanciadoraIntegradorService } from "../financiamento/services/financiadora-integrador.service";

@Component({
  selector: "app-financiadora-integrador",
  templateUrl: "./financiadora-integrador.component.html",
  styleUrls: ["./financiadora-integrador.component.scss"],
})
export class FinanciadoraIntegradorComponent implements OnInit {
  @Input() idIntegrador: number;
  @Input() somenteLeitura: boolean;

  financiadorasIntegrador: FinanciadoraIntegradorModel[] = [];
  financiadorasIntegradorBackup: FinanciadoraIntegradorModel[] = [];
  opcoesApto = [
    { id: true, descricao: "Apto" },
    { id: false, descricao: "Não Apto" },
  ];
  opcoesSituacao = [
    { id: true, descricao: "Sim" },
    { id: false, descricao: "Não" },
  ];

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private financiadoraIntegradorService: FinanciadoraIntegradorService
  ) {}

  ngOnInit() {
    this.buscarFinanciadorasIntegrador();
  }

  buscarFinanciadorasIntegrador() {
    this.carregandoService.mostra("buscarFinanciadorasIntegrador");

    this.financiadoraIntegradorService.buscarFinanciadoras(this.idIntegrador).subscribe(
      (itens) => {
        this.financiadorasIntegrador = itens.results;

        this.carregandoService.esconde("buscarFinanciadorasIntegrador");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFinanciadorasIntegrador");
        this.notificacaoService.erro(erro);
      }
    );
  }

  editar(financiadora: FinanciadoraIntegradorModel) {
    this.financiadorasIntegradorBackup.push(Object.assign({}, financiadora));

    financiadora.editando = true;
  }

  salvar(financiadora: FinanciadoraIntegradorModel) {
    this.carregandoService.mostra("salvarFinanciadora");
    
    this.removerBackup(financiadora.id, financiadora.financiadora.id);
    this.financiadoraIntegradorService.salvarFinanciadora(this.idIntegrador, financiadora).subscribe(
      (data) => {
        financiadora.editando = false;

        financiadora.id = data.result.id;
        financiadora.apto = data.result.apto;
        financiadora.dtAnalise = data.result.dtAnalise;
        financiadora.situacao = data.result.situacao;

        this.carregandoService.esconde("salvarFinanciadora");
        this.notificacaoService.sucesso("Financiadora atualizada com sucesso!");
      },
      (erro) => {
        this.carregandoService.esconde("salvarFinanciadora");
        this.notificacaoService.erro(erro);
      }
    );
  }

  cancelar(financiadora: FinanciadoraIntegradorModel) {
    const backup = this.buscarBackup(financiadora.id, financiadora.financiadora.id);

    if (backup) {
      financiadora.apto = backup.apto;
      financiadora.situacao = backup.situacao;

      this.removerBackup(financiadora.id, financiadora.financiadora.id);
    }

    financiadora.editando = false;
  }

  buscarBackup(idFinanciadoraIntegrador: number, idFinanciadora: number): FinanciadoraIntegradorModel | undefined {
    return this.financiadorasIntegradorBackup.find(
      (x) => x.id === idFinanciadoraIntegrador && x.financiadora.id === idFinanciadora
    );
  }

  removerBackup(idFinanciadoraIntegrador: number, idFinanciadora: number) {
    const idx = this.financiadorasIntegradorBackup.findIndex(
      (x) => x.id === idFinanciadoraIntegrador && x.financiadora.id === idFinanciadora
    );

    if (idx !== -1) {
      this.financiadorasIntegradorBackup.splice(idx, 1);
    }
  }
}
